export default __webpack_public_path__ + "static/media/add.b4bd6349.png";